import React from 'react';

import { CommonInputProps, CustomTagProps } from '../../types';
import { RCFormGroupAlertText, RCTag } from '../../';

/** props that form elements typically pass through */
export interface CheckableLabelProps extends Omit<CommonInputProps, 'tag' | 'name'> {
  /** Additional line of text below main label; sentence-case without ending punctuation. Not rendered if `variant` is set to `switch`. */
  sublabel?: React.ReactNode;

  htmlFor?: string;
  customTag?: CustomTagProps;

  // used by RCCheckbox when it's rendering a link instead of a form element
  renderAsDiv?: boolean;
}

export function RCCheckableLabel({
  label,
  htmlFor = undefined,
  errorText = undefined,
  sublabel = undefined,
  customTag = undefined,
  id = undefined,
  renderAsDiv = undefined,
}: CheckableLabelProps) {
  const Tag = renderAsDiv ? 'div' : 'label';

  return (
    <Tag
      className="rc-checkable-label"
      htmlFor={renderAsDiv ? null : htmlFor}
      id={id}
    >
      {label}
      {customTag && (
        <>
          <span className="mr-2" />
          <RCTag
            variant={customTag.variant || 'highlight'}
          >
            {customTag.label}
          </RCTag>
        </>
      )}
      {sublabel && (
        <span className="rc-checkable-label__sublabel">
          {sublabel}
        </span>
      )}
      {errorText && (
        <RCFormGroupAlertText errorText={errorText} />
      )}
    </Tag>
  );
}
